import {
	NAME_VALIDATION_MESSAGES,
	nameFieldSchema,
} from '@welbe/design-system';
import { z } from 'zod';

export const EmployeeSchema = z
	.object({
		insuranceId: z.string().nonempty(),
		firstName: nameFieldSchema,
		lastName: nameFieldSchema.optional(),
		middleName: nameFieldSchema.optional(),
		hasNoMiddleName: z.boolean().optional(),
		hasNoLastName: z.boolean().optional(),
		birthDate: z
			.string()
			.nonempty()
			.superRefine((data, ctx) => {
				const [year, month, day] = data.split('-').map(Number);
				const birthDate = new Date(year, month - 1, day);

				if (isNaN(birthDate.getTime())) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'Fecha inválida',
					});
					return;
				}

				const today = new Date();

				const maxAgeDate = new Date(
					today.getFullYear() - 120,
					today.getMonth(),
					today.getDate(),
				);

				if (birthDate > today) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'La fecha de nacimiento no puede ser futura',
					});
				}

				if (birthDate <= maxAgeDate) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: 'La edad debe ser menor a 120 años',
					});
				}
			}),
		gender: z.enum(['Hombre', 'Mujer', 'No binario']).optional(),
		nationalIdentity: z.string().optional(),
		hasGenericNationalIdentity: z.boolean().optional(),
		alternativeEmail: z.string().nonempty(),
		alternativePhone: z.string().optional(),
		email: z.string().optional(),
		phone: z.string().optional(),
		socialSecurityNumber: z.string().optional(),
		companyId: z.string().nonempty(),
		companyFancyName: z.string().nonempty(),
		branchOfficeId: z.string().nonempty(),
		branchOfficeName: z.string().nonempty(),
		companyBadgeNumber: z.string().nonempty(),
		corporateEmail: z.string().nonempty(),
		hiringDate: z.string().nullable().optional(),
		sector: z.string().optional(),
		shift: z.string().optional(),
		position: z.string().optional(),
		expositionAreas: z.array(z.string()).optional(),
		riskProfiles: z.array(z.string()).optional(),
		isRegistered: z.boolean().optional(),
		hasEmployeeMerged: z.boolean().optional(),
		siresProfile: z.object({
			countryCode: z.number().min(0),
			federalEntityCode: z.number().min(0),
			nationalityCode: z.number().min(0),
			gender: z.enum([
				'NO_ESPECIFICADO',
				'MASCULINO',
				'FEMENINO',
				'TRANSGENERO',
				'TRANSEXUAL',
				'TRAVESTI',
				'INTERSEXUAL',
				'OTRO',
			]),
			nationalIdentityGender: z.enum(['HOMBRE', 'MUJER', 'NO_BINARIO']),
			biologicalSex: z.enum(['HOMBRE', 'MUJER', 'INTERSEXUAL']),
			inheritanceRights: z.array(z.string()).optional(),
			regionalInfo: z.object({
				country: z.number().min(0),
				federalEntity: z.number().min(0),
				municipality: z.number().min(0),
				location: z.number().min(0),
			}),
		}),
	})
	.superRefine((data, ctx) => {
		if (!data.hasGenericNationalIdentity && !data.nationalIdentity?.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: NAME_VALIDATION_MESSAGES.required,
				path: ['nationalIdentity'],
			});
		}
	});
